import { Action } from '@ngrx/store';

export const LOAD_MATERIALS = '[Materials] Load material';
export const LOAD_MATERIALS_FAIL = '[Materials] Load material Fail';
export const LOAD_MATERIALS_SUCCESS = '[Materials] Load material Success';

export class LoadMaterials implements Action {
  readonly type = LOAD_MATERIALS;
  constructor(public payload: { task: string; group: string; search: string }) {}
}

export class LoadMaterialsFail implements Action {
  readonly type = LOAD_MATERIALS_FAIL;
  constructor(public payload: any) {}
}

export class LoadMaterialsSuccess implements Action {
  readonly type = LOAD_MATERIALS_SUCCESS;
  constructor(public payload: any[]) {}
}

export type MaterialsAction = LoadMaterials | LoadMaterialsFail | LoadMaterialsSuccess;
